import { LOGIN_USER, REGISTER_USER, COUNTRY_LIST, SET_COUNTRY, LOGIN_AD_USER, LOGOUT,  UNMOUNT_REGISTER, CLEAR_USER, VERIFY_CAPTCHA, GET_APP_SETTINGS } from '../constants/constants';

export const registerUser = (data: any) => {
    return {
        type: REGISTER_USER,
        payload: data
    }
}

export const loginUser = (data: any) => {
    return {
        type: LOGIN_USER,
        payload: data
    }
}

export const verifyCaptcha = (data: any) => {
    return {
        type: VERIFY_CAPTCHA,
        payload: data
    }
}

export const getAppSettings = () => {
    return {
        type: GET_APP_SETTINGS
    }
}

export const clearUser = () => {
    return {
        type: CLEAR_USER
    }
}

export const loginAdUser = (data: any) => {
    return {
        type: LOGIN_AD_USER,
        payload: data
    }
}

export const getCountries = () => {
    return {
        type: COUNTRY_LIST
    }
}

export const setCountry = () => {
    return {
        type: SET_COUNTRY
    }
}

export const logout = () => {
    return {
        type: LOGOUT
    }
}

export const unmountRegisterState = () => {
    return {
        type: UNMOUNT_REGISTER
    }
}




// WEBPACK FOOTER //
// ./src/actions/action.userAuth.tsx